/**
 * Option lists for AI Systems Register (mirrors server/constants/aiSystemsOptions.js)
 */
export const APPLICABLE_OPTIONS = ["Yes", "No", "Partial"];

export const SYSTEM_TYPES = [
  "In-house Developed",
  "Third-party Tool",
  "User-built Agent",
  "Adopted Software with AI Features",
  "Other",
];

export const AI_USE_TYPES = [
  "Content / Drafting",
  "Research / Information Retrieval",
  "Summarisation",
  "Meeting / Transcription",
  "Software Development / Coding",
  "Data Analysis",
  "Decision Support",
  "Process Automation",
  "Customer / Client Interaction",
  "Recruitment / People",
  "Image / Media Generation",
  "Security",
  "Other",
];

export const VALUE_CHAIN_ROLES = [
  "AI User",
  "AI Partner",
  "AI Provider",
  "AI Integrator",
];

export const BUSINESS_AREAS = [
  "Leadership",
  "People & Operations",
  "Finance",
  "Sales and Business Development",
  "Marketing",
  "Engineering",
  "Solutions and Architecture",
  "QA and Testing",
  "Client Delivery",
  "Information Security and Compliance",
  "Other",
];

export const LIFECYCLE_STAGES = [
  "Development",
  "Pilot",
  "Deployed",
  "Under Review",
  "Decommissioned",
];

export const TRAINING_DATA_CATEGORIES = [
  "Text",
  "Images",
  "Structured Data",
  "Sensor Data",
  "Other",
];

export const OPERATIONAL_DATA_TYPES = [
  "Public Information",
  "Internal",
  "Non-Confidential",
  "Nikao Confidential Information",
  "Client Information",
  "Client Confidential Information",
  "Personal Data",
  "Special Category Personal Data",
  "Source Code / Technical Information",
  "Intellectual Property",
  "No Organisational Data",
  "Other",
];

export const PERSONAL_DATA_OPTIONS = ["Yes", "No"];

export const CLIENT_CONFIDENTIAL_OPTIONS = [
  "No",
  "Client Data",
  "Nikao Confidential Data",
  "Both",
];

export const PROVISIONING_OPTIONS = [
  "SaaS",
  "Public Cloud",
  "Private Cloud",
  "On-premise",
  "Containerised",
  "Hybrid",
  "Other",
];

export const INFRASTRUCTURE_PROVIDERS = [
  "Microsoft Azure",
  "AWS",
  "Google Cloud Platform",
  "OpenAI-managed",
  "Other Provider-managed",
  "Nikao On-premise",
  "Client-managed",
  "Other",
  "Unknown",
];

export const HUMAN_OVERSIGHT_OPTIONS = [
  "Not Applicable",
  "Human reviews all outputs",
  "Human reviews outputs before external use",
  "Human reviews outputs before decision/action",
  "Sample / periodic human review",
  "Automated / no routine human review",
  "Other",
];

export const INCIDENT_NOTIFY_ROLES = [
  "System Owner",
  "AIMS Owner",
  "Information Security",
  "Business Owner",
  "Client Owner",
  "Executive Sponsor",
  "Other",
];

export const ASSESSMENT_STATUS_OPTIONS = [
  "Not Assessed",
  "Not Required",
  "In Progress",
  "Completed",
];

export const APPROVAL_STATUS_OPTIONS = [
  "Under Assessment",
  "Approved",
  "Approved with Conditions",
  "Restricted",
  "Not Approved",
  "Retired",
];

export const RECORD_STATUS_OPTIONS = ["Draft", "Active"];

/** Suggested owner / accountability titles for AI system ownership */
export const OWNER_ROLE_SUGGESTIONS = [
  "InfoSec Director",
  "AIMS Owner",
  "System Owner",
  "Business Owner",
  "Client Owner",
  "Executive Sponsor",
  "Information Security",
];

export const GOVERNANCE_ROLE_OPTIONS = [
  "System Owner",
  "AIMS Owner",
  "Information Security",
  "Business Owner",
  "Client Owner",
  "Executive Sponsor",
  "Data Protection Officer",
  "Engineering Lead",
  "Product Owner",
  "Other",
];
